<form [formGroup]="form">
  @if (fieldName) {
    <div class="form-group">
      <p-float-label>
        @switch (displayType) {
          @case (DisplayType.Money) {
            <p-inputNumber
              #control
              [formControlName]="fieldName?.toString()"
              currency="USD"
              locale="en-US"
              mode="currency"
              [required]="isRequired()"
              [readonly]="readonly"
              [s-blur]="attribute?.dataClassification ?? 'Financial'"
              [inputId]="fieldName.toString() + '-number'"
              (onBlur)="emitBlur($event)"
              (onblur)="emitBlur($event)"
              />
          }
          @case (DisplayType.Rate) {
            <p-inputNumber
              #control
              [formControlName]="fieldName?.toString()"
              locale="en-US"
              prefix="$"
              mode="decimal"
              [minFractionDigits]="2"
              [maxFractionDigits]="5"
              [required]="isRequired()"
              [readonly]="readonly"
              [s-blur]="attribute?.dataClassification ?? 'Financial'"
              [inputId]="fieldName.toString() + '-number'"
              (onBlur)="emitBlur($event)"
              (onblur)="emitBlur($event)"
              [s-blur]="attribute?.dataClassification"
              />
          }
          @case (DisplayType.PercentageFromWholeNumber) {
            <p-inputNumber
              #control
              [formControlName]="fieldName?.toString()"
              suffix="%"
              locale="en-US"
              mode="decimal"
              [minFractionDigits]="0"
              [maxFractionDigits]="maxFractionDigits"
              [required]="isRequired()"
              [readonly]="readonly"
              [s-blur]="attribute?.dataClassification"
              [inputId]="fieldName.toString() + '-number'"
              (onBlur)="emitBlur($event)"
              (onblur)="emitBlur($event)"
              />
          }
          @case (DisplayType.Miles) {
            <p-inputNumber
              #control
              [formControlName]="fieldName?.toString()"
              locale="en-US"
              [maxFractionDigits]="1"
              [required]="isRequired()"
              [readonly]="readonly"
              [s-blur]="attribute?.dataClassification"
              [inputId]="fieldName.toString() + '-number'"
              (onBlur)="emitBlur($event)"
              (onblur)="emitBlur($event)"
              />
          }
          @default {
            <p-inputNumber
              #control
              [formControlName]="fieldName?.toString()"
              locale="en-US"
              mode="decimal"
              [maxFractionDigits]="maxFractionDigits"
              [required]="isRequired()"
              [readonly]="readonly"
              [s-blur]="attribute?.dataClassification"
              [inputId]="fieldName.toString() + '-number'"
              (onBlur)="emitBlur($event)"
              (onblur)="emitBlur($event)"
              />
          }
        }
        <label [for]="fieldName?.toString() + groupName?.toString()"
          >{{ label ?? 'Number' }}@if (isRequired()) {
          <span style="color: red">*</span
            >
            }@if (attribute?.displayNameSuffixIcon) {
            <i inline>{{ attribute.displayNameSuffixIcon }}</i>
            }</label
            >
          </p-float-label>
          <div>
            @if (displayHint) {
              <small class="block">{{ displayHint }}</small>
            }
            <s-form-error-input
              [groupName]="groupName"
              [fieldName]="fieldName"
              [form]="form"
              [apiError]="apiError"
              [schema]="schema"
              />
            </div>
          </div>
        }
      </form>
